import React, { Fragment, useEffect } from "react";
import { Card, Row, Col, Form} from "react-bootstrap";
import { deepCopy } from "../Shared/Utility/DeepCopy";
import { MedicalEducation, MedicalEducationModel } from "../Physician/Models/MedicalEducationModel";

interface IProps {
    medicalEducationModel: MedicalEducationModel;
    medicalEducation: MedicalEducation;
    runValidation: boolean;
    isFormValid: boolean;
    updateMedicalEducation: (medicalEducation: MedicalEducation) => void;
    updateMedicalEducationValidation: (isValid: boolean) => void;
}

export function MedicalEducationCard(props: IProps) {

    useEffect(() => {
        if (props.runValidation) validate();
    }, [props.runValidation]);

    const updateLocationId = (e: React.ChangeEvent<HTMLSelectElement>) => {
        var updated = deepCopy(props.medicalEducation);
        updated.locationId = e.target.value ? props.medicalEducationModel.medicalEducationLocationLookupList.find(_ => _.id === parseInt(e.target.value)).id : null;
        props.updateMedicalEducation(updated);
    }

    const updateGraduationYear = (e: React.ChangeEvent<HTMLSelectElement>) => {
        var updated = deepCopy(props.medicalEducation);
        updated.graduationYear = parseInt(e.target.value);
        props.updateMedicalEducation(updated);
    }

    const validate = () => {
        const form = document.getElementById("medicalSchoolForm") as HTMLFormElement;

        props.updateMedicalEducationValidation(form.checkValidity());
    }

    return (
        <Fragment>
            <Card className="mb-4" border="pp-secondary-grey">
                <Card.Body>
                    <Card.Title className="mb-0 font-weight-bolder">
                        <span className="text-pp-primary">Medical School</span>
                    </Card.Title>
                    <Row className="mt-3">
                        <Col xs={12} md={12} lg={12} xl={12}>
                            <Form noValidate id="medicalSchoolForm" validated={props.isFormValid === false}>
                                <Row noGutters className="align-items-end">
                                    <Col xs={12} md={12} lg={4} xl={4} className="px-2">
                                        <Form.Group controlId="graduationYear">
                                            <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">Graduation Year<span className="text-pp-primary ml-2">*</span></Form.Label>
                                            <Form.Control 
                                                required
                                                type="number" 
                                                placeholder="YYYY" 
                                                min={1900} 
                                                max={9999} 
                                                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {updateGraduationYear(e)}}>
                                                </Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={12} lg={4} xl={4} className="px-2">
                                        <Form.Group controlId="medicalSchoolLocationId">
                                            <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">Medical School Location<span className="text-pp-primary ml-2">*</span></Form.Label>
                                                <Form.Control as="select"
                                                    required
                                                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => { updateLocationId(e)}}
                                                    defaultValue={""}>
                                                    <option hidden value="">Select One</option>
                                                    {props.medicalEducationModel.medicalEducationLocationLookupList.map(x => (<option value={x.id} key={x.id}>{x.name}</option>))}
                                                </Form.Control>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Fragment>
    );
}

export default MedicalEducationCard;
